import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getContractChangeHistory } from '../../../redux/actions/contract'
import CenterChangeFormHistoryWidget from '../../../widgets/contractChangeForm/CenterChangeFormHistoryWidget'

export default function ContractChangeFormHistory() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getContractChangeHistory(projectVersionId)
      setSchema(response.model)
      // setSchema(mock)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema && (
          <>
            <CenterChangeFormHistoryWidget schema={schema} />
          </>
        )}
        <br />
      </SidebarProposal>
    </>
  )
}

const mock = {
  header: 'ประวัติบันทึกแก้ไขเพิ่มเติมข้อตกลง',
  value: [
    {
      id: '861F65E1-85B7-45A4-8E8D-1A9BCFE8A1DC',
      seqNo: 1,
      contractNo: 'C64-07-000050',
      approveDate: '01-09-2025',
      formStatus: 'บันทึกข้อมูล',
      singType: 'กระดาษ',
    },
  ],
}
